export const FETCH_FOLLOW_UP_COMMITE_REQUEST="FETCH_FOLLOW_UP_COMMITE_REQUEST";
export const FETCH_FOLLOW_UP_COMMITE_SUCCESS="FETCH_FOLLOW_UP_COMMITE_SUCCESS";
export const FETCH_FOLLOW_UP_COMMITE_FAIL="FETCH_FOLLOW_UP_COMMITE_FAIL";

export const CREATE_FOLLOW_UP_COMMITE_REQUEST="CREATE_FOLLOW_UP_COMMITE_REQUEST";
export const CREATE_FOLLOW_UP_COMMITE_SUCCESS="CREATE_FOLLOW_UP_COMMITE_SUCCESS";
export const CREATE_FOLLOW_UP_COMMITE_FAIL="CREATE_FOLLOW_UP_COMMITE_FAIL";


export const UPDATE_FOLLOW_UP_COMMITE_REQUEST="UPDATE_FOLLOW_UP_COMMITE_REQUEST";
export const UPDATE_FOLLOW_UP_COMMITE_SUCCESS="UPDATE_FOLLOW_UP_COMMITE_SUCCESS";
export const UPDATE_FOLLOW_UP_COMMITE_FAIL="UPDATE_FOLLOW_UP_COMMITE_FAIL";


export const SHOW_FOLLOW_UP_COMMITE_REQUEST="SHOW_FOLLOW_UP_COMMITE_REQUEST";
export const SHOW_FOLLOW_UP_COMMITE_SUCCESS="SHOW_FOLLOW_UP_COMMITE_SUCCESS";
export const SHOW_FOLLOW_UP_COMMITE_FAIL="SHOW_FOLLOW_UP_COMMITE_FAIL";